<div class="srm-image" *ngIf="imagemSrmUrl as imagemUrl">
  <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
  <div class="image-wrapper" [style.width]="width">
    <div class="download-actions" *ngIf="!hasError">
      <a
        mat-icon-button
        class="download-icon-btn"
        [href]="imagemUrl"
        target="_blank"
        rel="noopener noreferrer"
        title="Baixar imagem PNG"
        aria-label="Baixar imagem PNG">
        <mat-icon>image</mat-icon>
      </a>
      <a
        mat-icon-button
        class="download-icon-btn"
        [href]="imagemSrmGpkgUrl"
        target="_blank"
        rel="noopener noreferrer"
        title="Baixar GPKG"
        aria-label="Baixar GPKG">
        <img src="assets/img/gpkg_icon.png"
          alt="Baixar GPKG"
          class="download-img-icon">
      </a>
    </div>

    <img
      *ngIf="!hasError"
      [src]="imagemUrl"
      [alt]="alt"
      class="img-responsive"
      (load)="onLoad()"
      (error)="onError()"
    />
    <div class="image-placeholder" *ngIf="hasError">Aguardando Imagem</div>
  </div>
</div>
